<template lang="pug">
div
	v-row.pa-0
		v-col(cols="3")
			v-select(v-model="day" :items="possibleDays" outlined :disabled="disabled")
		v-col(cols="5")
			v-select(v-model="month" :items="possibleMonths" outlined :disabled="disabled")
		v-col(cols="4")
			v-select(v-model="year" :items="possibleYears" outlined :disabled="disabled")
</template>

<script>
import dayjs from 'dayjs';

export default {
	name: 'Datepicker',
	props: ['value', 'maxAge', 'minAge', 'classnames', 'disabled'],
	data() {
		return {
			day: dayjs().format('DD'),
			month: dayjs().format('MM'),
			year: dayjs().format('YYYY')
		};
	},
	computed: {
		possibleDays() {
			const daysInMonth = this.$dayjs(
				`${this.year}-${this.month}`,
				'YYYY-MM'
			).daysInMonth();

			return [...Array(daysInMonth).keys()].map(i => {
				return { value: ('0' + (i + 1)).slice(-2), text: i + 1 };
			});
		},
		possibleMonths() {
			return [...Array(12).keys()].map(i => {
				return {
					value: ('0' + (i + 1)).slice(-2),
					text: this.$dayjs()
						.month(i)
						.format('MMMM')
				};
			});
		},
		possibleYears() {
			const years = [];
			const maxYear = this.maxAge ? this.$dayjs()
					.subtract(this.maxAge, 'year')
					.format('YYYY') : this.$dayjs().format('YYYY');
			const minYear = this.minAge ? this.$dayjs().subtract(this.minAge, 'year').year() : this.$dayjs().year();

			for (
				let i = maxYear;
				i <= minYear;
				i++
			) {
				years.push(i);
			}
			return years
				.map(i => {
					return { value: i.toString(), text: i.toString() };
				})
				.reverse();
		},
		fullDate: {
			get() {
				return `${this.year}-${this.month}-${this.day}`;
			},
			set(date) {
				if(date) {
					const parts = date.split('-');
					this.year = parts[0];
					this.month = parts[1];
					this.day = parts[2];
				} else {
					this.year = this.minAge ? this.$dayjs().subtract(this.minAge, 'year').year() : this.$dayjs().year();
					this.month = '01';
					this.day = '01';
				}
			}
		}
	},
	watch: {
		fullDate() {
			this.$emit('input', this.fullDate);
		},
		value(d) {
			this.fullDate = d;
		}
	},
	created() {
		this.fullDate = this.value;
	}
};
</script>
